import { ACTIONS } from "../interfaces/actionTypes/OffLineSupportType";
import AXIOS from "../../config/Axios";
import PrefixBeta from "../../config/ApiPrefixBeta";
import Prefix from "../../config/ApiPrefix";
import snackBarUpdate from "../../actions/snackBarActions";
import SecureStorage from "../../config/SecureStorage";
import headers from "../../helpers/headers";
import { AnyAction } from "redux";

export const showSuccessToast = (message: string, dispatch: Function) => {
    snackBarUpdate({
        payload: {
            message,
            status: true,
            type: "success",
        },
    })(dispatch);
};

export const handleApiError = (err: any, dispatch: Function) => {
    let title = "";
    const errorData = err?.response?.data;
    if (errorData?.errors || errorData?.detail || errorData?.message || errorData?.error) {
        title = JSON.stringify(
            errorData.errors || errorData.detail || errorData.message || errorData.error
        ).replace(/"|{|}|[|]/g, "");
    } else {
        title = "Something went wrong!";
    }

    snackBarUpdate({
        payload: {
            message: title,
            status: true,
            type: "error",
        },
    })(dispatch);
};


export const changePassword = (body: any) => async (dispatch: Function) => {
    try {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        await AXIOS.post(
            `${Prefix.api}/auth/password_reset/reset_password/`,
            body,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.CHANGE_PASSWORD, payload: null });
        snackBarUpdate({
            payload: {
                message: "Password Updated",
                status: true,
                type: "success",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const clickToCallBooking =
    (id: number, contact_type: string) => async (dispatch: Function) => {
        try {
            await AXIOS.get(
                `${Prefix.api}/booking/clicktocall/${id}/${contact_type}/`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CLICK_TO_CALL, payload: null });
            snackBarUpdate({
                payload: {
                    message: "Call Succeded",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            let title = "";
            if (err.response) {
                title = err?.response?.data?.errors;
            } else {
                title = "Something went wrong!";
            }
            snackBarUpdate({
                payload: {
                    message: title || "Something went wrong",
                    status: true,
                    type: "error",
                },
            })(dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getAllLeads = (query: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(`${Prefix.apiNew}/lead/v2/leads/${query}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_ALL_LEADS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getTopRCFreshLeads =
    (query: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/lead/lead/?${query === "49"
                    ? "multiple_category=49&latest_size=10&latest=true"
                    : "multiple_category=36,11&latest_size=10&latest=true"
                }`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_TOP_RC_FRESH_LEADS, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getTopCfreshLeads =
    (query: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/lead/lead/?category=7&latest_size=10&latest=true`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_TOP_C_FRESH_LEADS, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getRepeatedLead =
    (query: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/repeated_lead/`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_REPEATED_LEAD, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getLatestLeads = (query: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/lead/lead/${query}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_LATEST_LEAD, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const clickToCall =
    (id: number, contact_type: string, status: any) =>
        async (dispatch: Function) => {
            try {
                await AXIOS.get(
                    `${Prefix.api}/lead/clicktocall/${id}/${contact_type}/${status ? status : ""
                    }`,
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                );
                dispatch({ type: ACTIONS.CLICK_TO_CALL, payload: null });
                snackBarUpdate({
                    payload: {
                        message: "Call Succeded",
                        status: true,
                        type: "success",
                    },
                })(dispatch);
            } catch (err: any) {
                let title = "";
                if (err.response) {
                    title = err.response.data.errors || err.response.data.error || err.response.data.detail;
                } else {
                    title = "Something went wrong!";
                }
                snackBarUpdate({
                    payload: {
                        message: title || "Something went wrong",
                        status: true,
                        type: "error",
                    },
                })(dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };
export const getPinCode = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/phlebo/pincode/${url ? `?code=${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PIN_CODE, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getCities =
    (url: string, newUrl: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/core/cities/${url ? `?q=${url}` : newUrl ? newUrl : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_CITIES, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getDisplayCities =
    (url: string, newUrl: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(`${Prefix.api}/core/displaycities/${url ? `${url}` : ""}`, {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            });
            dispatch({ type: ACTIONS.GET_DISPLAY_CITIES, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };


export const getDosStatus = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/sample/itdose-sample-logs/${url ? `${url}` : ""}/`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        console.log(data, "Reducerdata");

        dispatch({ type: ACTIONS.GET_DOS_STATUS, payload: data?.data || [] });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.errors;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getAreaName = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/core/city-area/${url ? `?id=${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_AREA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getAgentList = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/data/${url ? `?code=${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_AGENTS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getPackage = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${PrefixBeta.api}/core/packages/crmdata${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getPackageTags = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/package/tags/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES_TAGS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPackageCategory = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/package/category/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES_CATEGORY, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getMultiplePackage =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/package/crmdata/${url ? `${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_MULTIPLE_PACKAGES, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getFamilyPackage = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/package/family-package/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_FAMILY_PACKAGES, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getFamilyPackageBooking =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/family-package-booking/${url ? `?${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_FAMILY_PACKAGES_BOOKING, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const postFamilyPackageBooking =
    (bookingData: any, id?: number) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/family-package-booking/${id ? `?${id}` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_FAMILY_PACKAGES_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booked",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const checkGeoFenceArea =
    (latitude: any, longitude: string, zone_id: string) =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.CHECK_GEOFENCE_AREA, payload: false });
            try {
                const { data } = await AXIOS.get(
                    `${Prefix.api}/booking/checking-geofence-area/?latitude=${latitude}&longitude=${longitude}&zone_id=${zone_id}`,
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                );
                dispatch({ type: ACTIONS.CHECK_GEOFENCE_AREA, payload: true });
            } catch (err: any) {
                handleApiError(err, dispatch);
                throw err;
            }
        };
export const checkGeoFenchMapMyIndia =
    (eloc: string, pincode: string, cityname: string = 'NA') => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA, payload: [] });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/checking-geofence-area-mapmyindia/?eloc=${eloc}&pincode=${pincode}&cityname=${cityname}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };

export const getMapMyIndiaAccessToken = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN, payload: [] });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/mapmyindia-auth-token/`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};

export const getPartners = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/partner/data/${url ? `?code=${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PARTNERS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getCoupons = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/coupon/data/${url ? `${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_COUPONS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const createNewBooking =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/data/${id ? `?${id}` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booked",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const createImagingBooking =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/imaging/${id ? `?${id}/` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_IMAGING_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booking Create Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const createBookWithMapBound =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/data/v1/${id ? `?${id}` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booked",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const createAdditionalBooking =
    (id: any, bookingData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/additional_booking/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_ADDITIONAL_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Family member added",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const updateAdditionalBooking =
    (id: any, bookingData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/ret_up_additional_booking/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_ADDITIONAL_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Family member updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getAllBookings = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/cc_booking/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: false });
        throw err;
    }
};

export const getBookings = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/data/${url ? `search?id=${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getBookingById = (id: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_BOOKING_ID_LOADER, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/data/${id ? `${id}/` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_BY_ID, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
    dispatch({ type: ACTIONS.SET_BOOKING_ID_LOADER, payload: false });
};


export const updateBooking =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/data/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booking Updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getLeadDetails =
    (id: string, shownumber: string = "false") =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.SET_LOADING, payload: true });
            try {
                if (shownumber === "true") {
                    var { data } = await AXIOS.get(
                        `${Prefix.api}/lead/lead-update/${id}/`,
                        {
                            headers: {
                                Authorization: `Token ${SecureStorage.getItem("token")}`,
                            },
                        }
                    );
                } else {
                    var { data } = await AXIOS.get(
                        `${Prefix.api}/lead/lead-update/${id}/`,
                        {
                            headers: {
                                Authorization: `Token ${SecureStorage.getItem("token")}`,
                            },
                        }
                    );
                }
                dispatch({ type: ACTIONS.GET_LEAD_DETAILS, payload: data });
            } catch (err: any) {
                handleApiError(err, dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };

export const updateLeadDetailsF_2 =
    (id: string, body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        const { followup_date, followup_time, language } = body;
        try {
            const { data } = await AXIOS.patch(
                `${Prefix.api}/lead/lead-update/${id}/`,
                { followup_date, followup_time, language },
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_LEAD_DETAILS, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Success",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const updateLeadDetailsF_1 =
    (id: string, body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        const {
            patient_name,
            patient_age,
            calling_gender,
            priority,
            content_number,
            whatsapp_contact,
            address,
            patient_city,
            patient_area,
        } = body;
        try {
            const { data } = await AXIOS.patch(
                `${Prefix.api}/lead/lead-update/${id}/`,
                {
                    patient_name,
                    patient_age,
                    calling_gender,
                    priority,
                    content_number,
                    whatsapp_contact,
                    address,
                    patient_city,
                    patient_area,
                },
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_LEAD_DETAILS, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Success",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getLeads = (body: any, url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/panel/search/${url ? `?${url}` : ""}`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_LEADS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const resetLeadDetails = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.LEAD_DETAILS_RESET });
};

export const resetBookings = () => async (dispatch: Function) => {
    dispatch({
        type: ACTIONS.BOOKING_RESET,
    });
};

export const getLeadById = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/lead/dashboard/`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_LEAD_BY_ID, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getLtvLead = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/lead/ltv/${id}`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_LTV_LEAD, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getPositiveCallsComments =
    (id: number) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/lead/lead-related-comments/${id}/`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_POSTIVE_CALLS_COMMENTS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const addPositiveCallComment =
    (body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        const { comment, callId } = body;
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/lead/lead-details/${callId}/`,
                {
                    comment,
                },
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            snackBarUpdate({
                payload: {
                    message: "Created!",
                    status: true,
                    type: "success",
                },
            })(dispatch);

            dispatch({
                type: ACTIONS.ADD_POSTIVE_CALLS_COMMENT,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const setCFreshComments = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    const {
        category,
        sub_category,
        lead_comment,
        comment,
        pincode,
        test,
        city,
        status,
        query,
        followup_date,
        followup_time,
        center,
        cityname,
        price,
        number,
        language,
        pannelName,
    } = body;
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/lead/status-allot/`,
            {
                category,
                sub_category,
                lead_comment,
                comment,
                pincode,
                test,
                city,
                status,
                query,
                followup_date,
                followup_time,
                center,
                cityname,
                price,
                number,
                language,
                pannelName,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SET_COMMENTS, payload: data });
        snackBarUpdate({
            payload: {
                message: "Success!",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const addComment = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    const { comment, callId } = body;
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/lead/lead-details/${callId}/`,
            {
                comment,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        snackBarUpdate({
            payload: {
                message: "Created!",
                status: true,
                type: "success",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.ADD_COMMENT, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const createCall = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    const { name, phone_no, source } = body;

    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/lead/generate-lead-by-user/`,
            {
                name,
                phone_no,
                source,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.CREATE_CALL, payload: data.lead });
        snackBarUpdate({
            payload: {
                message: "Success!",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getLeadSource = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(`${Prefix.api}/lead/lead-source/`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_LEAD_SOURCE, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getAllRecordings = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/offline-call-recordings/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_RECORDINGS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getBookingsComments =
    (id: number) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/lead/booking-related-comments/${id}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_BOOKINGS_COMMENTS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const addBookingsComment = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    const { comment, bookingId } = body;
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/lead/booking-details/${bookingId}/`,
            {
                comment,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        snackBarUpdate({
            payload: {
                message: "Created!",
                status: true,
                type: "success",
            },
        })(dispatch);

        dispatch({
            type: ACTIONS.ADD_BOOKINGS_COMMENT,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getWhatsappComments = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/asigned-chat-lead/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_WHATSAPP_COMMENTS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};


export const getWhatsappCommentsByLead =
    (url: string) => async (dispatch: Function) => {
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/communication/whatsapp_message_comment/?${url}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_WHATSAPP_COMMENTS_BY_LEAD,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };

export const sendWhatsappComments =
    (leadId: any, message: any, fromsales: any) => async (dispatch: Function) => {
        try {
            const { data } = fromsales === true ?
                await AXIOS.post(
                    `${Prefix.api}/communication/send_whatsapp_message_offline/${leadId}/`,
                    { "message": message, "from_sales": fromsales },
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                ) : await AXIOS.post(
                    `${Prefix.api}/communication/send_whatsapp_message_offline/${leadId}/`,
                    message,
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                );
            dispatch({
                type: ACTIONS.SEND_WHATSAPP_COMMENTS,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Message Sent.",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };

export const getCallStats = () => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/analytics/panaluser_calls/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_CALL_STATS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getUserStats = () => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/analytics/daily-activity/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_USER_STATS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const raiseNewComplaint =
    (type: any, body: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/${type}/create/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.RAISE_COMPLAINT,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Ticket Raised",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getQueryTickets =
    (type: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/${type}/data/${id ? `?${id}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_COMPLAINTS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const updateQueryTicket =
    (type: any, body: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/${type}/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.RAISE_COMPLAINT,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Ticket Updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const complaintReset = () => async (dispatch: Function) => {
    dispatch({
        type: ACTIONS.RAISE_COMPLAINT,
        payload: {},
    });
};

export const assignDoctor = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/booking/doctor_cunsultation/`,
            body,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.ASSIGN_DOCTOR,
            payload: data,
        });
        snackBarUpdate({
            payload: {
                message: "Doctor Assigned",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getDoctorBookings = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/doctor_cunsultation/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_BOOKING_LIST,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getDoctorBookingById = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/doctor_cunsultation/${id}/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_BOOKING_BY_ID,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const sendNewFeedback =
    (id: any, body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/doctor_cunsultation/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.SEND_FEEDBACK,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Feedback Sent",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getAvailableSlots =
    (collection_date: any, customer_zone: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/booking_slot_collection_date/?collection_date=${collection_date ? collection_date : ""
                }&customer_zone=${customer_zone ? customer_zone : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_AVAILABLE_SLOTS, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const searchCall = (body: any) => async (dispatch: Function) => {
    const { search_by, value } = body;
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/panel/search/?self=true`,
            {
                search_by,
                value,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SEARCH_CALL, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getPhlebos = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/phlebo/data/${url ? `?code=${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PHLEBOS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getBreakResponse = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/data/${url ? `?${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BREAK_RESPONSE, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPanelBreak = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/panel_break/${url ? `${url}/` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PANEL_BREAK, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPaymentSendLink = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/payment/send_link/${url ? `${url}/` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PAYMENT_SEND_LINK, payload: data });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.detail;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPaymentReSendLink =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/payment/resend_link/${url ? `${url}/` : ""}`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_PAYMENT_RESEND_LINK, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getPaymentCancelLink =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/payment/cancel_link/${url ? `${url}/` : ""}`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_PAYMENT_CANCEL_LINK, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getLabDetails = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/panel_in_lab/${url ? `${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_LAB_DETAILS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getSmsDetails = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/notification/booking_sms/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_SMS_DETAILS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getEmailDetails = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/notification/email_sms/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_EMAIL_DETAILS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getSmsReportSend = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/mail_report_sms/${url ? `${url}/` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_SMS_REPORT_SEND, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getCenterInfo = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/data/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_CENTER_INFORMATION, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_CENTER_INFORMATION, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getSubCenterInfo = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/center-address/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_SUB_CENTER_INFORMATION, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);;
        dispatch({ type: ACTIONS.GET_CENTER_INFORMATION, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getSMSLink = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/notification/report_feedback/${url ? `${url}/` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_SMS_LINK, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getNotificationMessage =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/notification/send/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_NOTIFICATION_MESSAGE, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const sendNotification = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/notification/send/`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SEND_NOTIFICATION, payload: data });
        snackBarUpdate({
            payload: {
                message: "token received",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getReportDownload = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/report_status/${url ? `${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_REPORT_DOWNLOAD, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getReportStatus = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/status/${url ? `${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_REPORT_STATUS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getUnmaskedNumber =
    (id: any, source: any, type: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/panel/unmasked/${id ? `${id}` : ""}/${source ? `${source}` : ""
                }/${type ? `${type}` : ""}/`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_UNMASKED_NUMBER, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getUserDetails = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/auth/shortprofile/${url ? url : ""}`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFirebaseNotification =
    (body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/notification/token_save/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_FIREBASE_NOTIFICATION, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getZone = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/phlebo/zone/data/${url ? `?city_name=${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_ZONE,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getUserData = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/auth/data/`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_USER_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getNotificationType =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(`${Prefix.api}/notification/type/`, {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            });
            dispatch({ type: ACTIONS.GET_NOTIFICATION_TYPE, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getTodaysMissedCalls =
    (url: string) => async (dispatch: Function) => {

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/analytics/panaluser_missed_calls_count/${url ? `${url}` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_TODAYS_MISSED_CALLS, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);

            throw err;
        }
    };
export const getRepeatedList = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/lead/repeated_lead/${url ? `?${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_REPEATED_LEADS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const updateRepeatedList =
    (id: any, leadData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/lead/repeated_lead/${id}/`,
                leadData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATED_REPEATED_LIST, payload: data });
            snackBarUpdate({
                payload: {
                    message: "LEAD UPDATED SUCCESSFULLY",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getTimeslots = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/phlebo/timeslots/`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({
            type: ACTIONS.GET_TIMESLOTS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getImagingTimeslots = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/phlebo/imaging-package-slots/${url ? url : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_IMAGING_TIMESLOTS,
            payload: data,
        });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.detail;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getRedCoing = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    dispatch({ type: ACTIONS.GET_RED_COIN, payload: [] });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/coupon/available-coins/?phonenumber=${url}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_RED_COIN,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getLeadStatus = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/lead/lead-status/${url ? url : ""}`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({
            type: ACTIONS.GET_LEAD_STATUS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getPrescriptionData =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/prescription_upload-crm/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_PRESCRIPTION_DATA, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getDoctorInfoById = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/ref_doctor/?center_address=${id}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_DOCTOR_INFO_BY_ID,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const imaginBookingDisposition =
    (body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/lead/imaging-disposition/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.POST_IMAGING_BOOKING_DISPOSITION,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Booking Cancel Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getImagingTicket = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/imaging-ticket/${url ? url : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_IMAGING_TICKET, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const sendInitialMessage = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/send_imaging_initial_message/${id}/`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SEND_INITIAL_WHATSAPP_MESSAGE, payload: data });
        snackBarUpdate({
            payload: {
                message: "Initial Message Send Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getImagingRaiseTicket =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/imaging-ticket/?raised=false${url ? url : ""}`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_IMAGING_RAISE_TICKET, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getImagingTicketCount =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/imaging-ticket-count/`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_IMAGING_TICKET_COUNT, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateImagingTicketStataus =
    (id: any, ticketStatus: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/imaging-ticket/${id}/`,
                ticketStatus,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_IMAGING_TICKET, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Ticket Updated Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const createImagingBookingCustom =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/imaging-custom/${id ? `?${id}/` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_IMAGING_BOOKING_CUSTOM, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booking Create Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            let title = "";
            if (err.response.data?.errors) {
                title = JSON.stringify(err.response.data?.errors).replace(
                    /"|{|}|[|]/g,
                    ""
                );
            } else {
                title = "Something went wrong!";
            }
            snackBarUpdate({
                payload: {
                    message: title || "Something went wrong",
                    status: true,
                    type: "error",
                },
            })(dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getTicketData = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/tasks/${url ? `${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_TICKET_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getTicketCategories = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/categories/?category_type=grievance${url ? `${url}/` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_TICKET_CATEGORIES, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getTicketSubCategories =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/redtech/sub-categories/${url ? `${url}` : ""}`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_TICEKT_SUB_CATEGORIES, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const CreateTaskTicket = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/redtech/greviance-tickets/`, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.CREATE_TASK_TICKET, payload: data });
        snackBarUpdate({
            payload: {
                message: "Task Created Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        let title = "";
        if (err?.response?.data) {
            title = JSON.stringify(err.response.data).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else if (err?.response?.data?.errors) {
            title = JSON.stringify(err.response.data?.errors).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else if (err?.response?.data?.msg) {
            title = JSON.stringify(err.response.data?.msg).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getRedTechComment = (id: number) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/comments/?ticket=${id}&ordering=-created_at`,

            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_RED_TECH_COMMENT,
            payload: data,
        });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err?.response?.data?.errors;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const postRedTechComment = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/redtech/comments/`, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({
            type: ACTIONS.POST_RED_TECH_COMMENT,
            payload: data,
        });
        snackBarUpdate({
            payload: {
                message: "Message Created",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.message;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getHoldCancelBooking =
    (query: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/booking-data-pickup-set/`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_HOLD_CANCEL_BOOKING, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getQualityScoringReport =
    (filter: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/communication/quality-scoring-report/qef/${filter ? `${filter}` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_QUALITY_SCORING_REPORT, payload: data });
        } catch (err: any) {
            let title = "";
            if (err.response.data.errors.lead) {
                title = err.response.data.errors.lead[0];
            } else if (err.response) {
                title = JSON.stringify(err.response.data?.errors).replace(
                    /"|{|}|[|]/g,
                    ""
                );
            } else {
                title = "Something went wrong!";
            }
            snackBarUpdate({
                payload: {
                    message: title || "Something went wrong",
                    status: true,
                    type: "error",
                },
            })(dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getQualityScoringReportForBackUp =
    (filter: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/communication/quality-scoring-report/qef/${filter ? `${filter}` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_QUALITY_SCORING_REPORT_FOR_BACKUP,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getceCentre = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/ce_center/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_CE_CENTER_FOR_CC,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const checkGeoFenchMapMyIndiaPilot =
    (eloc: string, cityname: string, address: string, leadId: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA, payload: [] });
        dispatch({ type: ACTIONS.SET_GEO_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/checking-geofence-area-mapmyindia_2/?eloc=${eloc}&cityname=${cityname}&address=${address}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA,
                payload: data,
            });
        } catch (err: any) {
            let title = "";
            if (err?.response) {
                title = err.response.data.errors;
                dispatch({ type: ACTIONS.SET_GEO_CHECK_ERROR, payload: err?.response?.data?.errors });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_CITYID, payload: err?.response?.data?.cityid });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_LATITUDE, payload: err?.response?.data?.latitude });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_LONGITUDE, payload: err?.response?.data?.longitude });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_ZONEID, payload: err?.response?.data?.zoneid });
            } else {
                title = "Something went wrong!";
                dispatch({ type: ACTIONS.SET_GEO_CHECK_ERROR, payload: "" });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_CITYID, payload: "" });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_LATITUDE, payload: "" });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_LONGITUDE, payload: "" });
                dispatch({ type: ACTIONS.SET_GEO_CHECK_ZONEID, payload: "" });
            }
            snackBarUpdate({
                payload: {
                    message: title || "Something went wrong",
                    status: true,
                    type: "error",
                },
            })(dispatch);
            dispatch({ type: ACTIONS.SET_GEO_LOADING, payload: false });
            throw err;
        }
    };
export const createPilotNewBooking =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/data_v2/${id ? `?${id}` : ""}`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_PILOT_BOOKING, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Booked",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getBookingQueryTickets = (id: any) => async (
    dispatch: Function
) => {
    dispatch({ type: ACTIONS.SET_NEW_TICKET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(

            `${Prefix.api}/redtech/csticket/${id ? `${id}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_BOOKING_COMPLAINTS,
            payload: data,
        });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    } catch (err: any) {
        let title = "";
        if (err?.response?.data?.detail) {
            title = JSON.stringify(err?.response?.data?.detail);
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const updateActionDisposition =
    (type: any, body: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/booking/booking_ticket/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.UPDATE_DISPOSITION,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Ticket Updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateTicketStatus =
    (body: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/redtech/csticket/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.UPDATE_TICKET_STATUS,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Ticket Updated Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getTicketComments = (id: number) => async (
    dispatch: Function
) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/csticket/comments/${id}`,

            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_TICKET_COMMENTS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const checkGeoFenchMapMyIndiaPilotForCustomerAddress =
    (eloc: string, pincode: string, cityname: string = 'NA') => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA_FOR_CUSTOMER_ADDRESS, payload: [] });
        dispatch({ type: ACTIONS.SET_GEO_LOADING_FOR_CUSTOMER, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/checking-geofence-area-mapmyindia_2/?eloc=${eloc}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA_FOR_CUSTOMER_ADDRESS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_GEO_LOADING_FOR_CUSTOMER, payload: false });
            throw err;
        }
    };

export const getWhatsappTemplate = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/message-template/?message_type=WHATSAPP`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_WHATSAPP_TEMPLATE,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const createWhatsappTemplate =
    (templateData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/communication/send_whatsapp_temp/?${templateData}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.CREATE_WHATSAPP_TEMPLATE, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Message Sent Successfully.",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };


export const getBiomarkerScreening =
    (id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_BIOMARKER_LOADER, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/biomarker_screening/${id ? `?${id}` : ""}`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_BIOMARKER_SCREENING, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
        dispatch({ type: ACTIONS.SET_BIOMARKER_LOADER, payload: false });
    };
export const resetBiomarker = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.BIOMARKER_RESET });
};
export const getBiomarkerUltasound =
    (id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}booking/ultasound_details/${id ? `?booking_id=${id}` : ""
                }`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_BIOMARKER_ULTASOUND, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getAdditionalMember = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/additional_booking/${id}/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_ADDITIONAL_MEMBER, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getNewPackage = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${PrefixBeta.api}/core/packages/crmdata${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getAllNewBookings = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${PrefixBeta.api}/core/bookings/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: data });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.detail;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong!",
                status: true,
                type:
                    err.response.data.detail ===
                        "An Email has been sent to your registered mail address"
                        ? "success"
                        : "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: false });
        throw err;
    }
};
export const getCommunicationOnWhatsapp = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/on-whatsapp/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_SEND_LOCATION_REQUEST,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const SendLocationRequest = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/communication/send-location-request/`, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.SEND_LOCATION_REQUEST, payload: data });
        snackBarUpdate({
            payload: {
                message: "Message Sent Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getCrmLeadAddress = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/auth/address-crm/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_CRM_LEAD_ADDRESS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const postCrmLeadAddress = (body: any, lead_id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LEAD_ADDRESS_LOADER, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/auth/address-crm/?lead_id=${lead_id}`,
            body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.POST_CRM_LEAD_ADDRESS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
    dispatch({ type: ACTIONS.SET_LEAD_ADDRESS_LOADER, payload: false });
};
export const verifyLocation = (id: any) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.put(
            `${Prefix.api}/booking/verify-location/${id}`,
            {},
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.LOCATION_VERIFIED,
            payload: data,
        });
        snackBarUpdate({
            payload: {
                message: "Location Verified Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }

};

export const postCrmLeadAddressModal = (body: any, lead_id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/auth/address-crm/?lead_id=${lead_id}`,
            body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.POST_CRM_LEAD_ADDRESS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getAddressDetailsLatLong = (lat: any, long: any, lead: any, bookingId: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.GET_ADDRESS_DETAILS_LAT_LONG, payload: [] });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/auth/get-address-details-lat-long/?latitude=${lat}&longitude=${long}&lead_id=${lead}&booking_id=${bookingId}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_ADDRESS_DETAILS_LAT_LONG, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const initiateRefund = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/payment/refund-payment/`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.INITIATE_REFUND, payload: data });
        snackBarUpdate({
            payload: {
                message: "Refund Initiate successfully!",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getWhatsappMessageStatus = (addressId: any) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/auth/address/${addressId ? `${addressId}/` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_WHATSAPP_MESSAGE_STATUS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const getLeadDispostion = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/lead/status-category/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_LEAD_DISPOSITION_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const postDispositionData = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    const {
        category,
        sub_category,
        lead_comment,
        comment,
        pincode,
        test,
        city,
        status,
        query,
        followup_date,
        followup_time,
        center,
        cityname,
        price,
        number,
        language,
        pannelName,
    } = body;
    try {
        const { data } = await AXIOS.post(
            `${Prefix.apiv2}/lead/v2/lead-status-update/`,
            {
                category,
                sub_category,
                lead_comment,
                comment,
                pincode,
                test,
                city,
                status,
                query,
                followup_date,
                followup_time,
                center,
                cityname,
                price,
                number,
                language,
                pannelName,
            },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.POST_DISPOSITION_DATA, payload: data });
        snackBarUpdate({
            payload: {
                message: "Success!",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getReferralCurrentBalance = (mobile: any) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/coupon/referral-current-balance/${mobile ? `?mobile=${mobile}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_REFERRAL_CURRENT_BALANCE,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });

        throw err;
    }
};

export const getCouponReferralValidation = (code: any, mobile: any) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/coupon/referral_validate_crm/${code ? `?code=${code}` : ""}${mobile ? `&mobile=${mobile}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_COUPON_REFERRAL_VALIDATION,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};

export const getLeadSubscriptionsData = () => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/auth/subscriptions/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_LEAD_SUBSCRIPTIONS_DATA,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const getIndividualWhatsappChat = (url: any) => async (
    dispatch: Function
) => {
    // dispatch({ type: ACTIONS.SET_LOADING_INDIVIDUAL_CHAT, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/whatsapp_message_comment/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_INDIVIDUAL_WHATSAPP_CHAT,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const getFailedReportData = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(

            `${Prefix.api}/booking/failed-report/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_FAILED_REPORT_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getLatestBookingUsingLead = (leadId: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/latest-booking/${leadId ? `?lead_id=${leadId}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.LATEST_BOOKING_USING_LEAD,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const getQueueNumber = () => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/in-queue/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.QUEUE_NUMBER,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const sendLastReportToLead = (body: any, leadId: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/communication/send-last-report/${leadId ? `?lead_id=${leadId}` : ""}`,
            body,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.SEND_LAST_REPORT_TO_LEAD,
            payload: data,
        });
        snackBarUpdate({
            payload: {
                message: "Report Sent Successfully.",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }

};
export const signOutInWhatsappChat = (value: string, body: any) => async (dispatch: Function) => {

    const { get_chat, offline } = body;
    try {
        const { data } = await AXIOS.patch(
            `${Prefix.api}/panel/sign-out/`, { get_chat, offline },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SIGN_OUT_IN_WHATSAPP_CHAT, payload: data });
        snackBarUpdate({
            payload: {
                message: value ? "Sign In Successfully" : "Sign Out Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const updateLeadDetails =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/lead/lead-update/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_LEADS, payload: data });
            snackBarUpdate({
                payload: {
                    message: "LEAD UPDATED SUCCESSFULLY",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const sendReportById = (id: number, url: string, type: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/mail_report_sms_manual_email/${id}/${type}/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SEND_REPORT_BY_ID, payload: data });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response?.data?.detail;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);

        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFailedReportDataById = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(

            `${Prefix.api}/booking/failed-report/${url ? `${url}/` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_FAILED_REPORT_DATA_BY_ID, payload: data });
    } catch (err: any) {
        let title = "";
        if (err.response.data?.errors) {
            title = JSON.stringify(err.response.data?.errors).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        // dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const sentReportDataById = (reportData: any, id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(

            `${Prefix.api}/booking/failed-report/${id ? `${id}/` : ""}`,
            reportData,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SENT_REPORT_DATA_BY_ID, payload: data });
        snackBarUpdate({
            payload: {
                message: "Report Sent.",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        // dispatch({ type: ACTIONS.GET_BOOKING_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getReportSendManual = (url: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/mail_report_sms_manual_email/${url ? `${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_REPORT_SEND_MANUAL, payload: data });
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.detail;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const switchChatAgent = (id: string, lastMessageId: any, body: any) => async (dispatch: Function) => {

    const { skill } = body;
    try {
        const { data } = await AXIOS.patch(
            `${Prefix.api}/lead/switch_chat_agent/${id}?msg_id=${lastMessageId}`, { skill },
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SWITCH_CHAT_AGENT_IN_WHATSAPP_CHAT, payload: data });
        snackBarUpdate({
            payload: {
                message: "Chat Switch Successfully.",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const holdTheChat = (leadId: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/lead/hold_chat/${leadId ? leadId : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.HOLD_THE_CHAT,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const getAllRedtechTicketsUsingLead = (leadId: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/all-ticket/${leadId ? `?lead_id=${leadId}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.REDTECH_TICKETS_USING_LEAD,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};

export const getDashboardPrescription = () => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/prescription_disapi/`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_DASHBOARD_PRESCRIPTION, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const addPrescriptioData = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/booking/prescription_reader/`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.SET_PRESCRIPTION_DATA, payload: data });
        snackBarUpdate({
            payload: {
                message: "Success!",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const updatePrescriptionDisposition =
    (id: number) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.patch(
                `${Prefix.api}/booking/prescription_dispose/${id}/`,
                { disposition: "confirmed" },
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_PRESCRIPTION_DISPOSITION, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Success",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const startWhatsappChat = (leadId: string, passKey: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/greetings-msg/?lead_id=${leadId}${passKey == "true" ? `&from_sales=true` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.START_WHATSAPP_CHAT, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const addressJsonPost = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/booking/saved-address/`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.ADDRESS_JSON_POST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getNewLeadDetails =
    (id: string, shownumber: string = "false") =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.SET_LOADING, payload: true });
            try {
                if (shownumber === "true") {
                    var { data } = await AXIOS.get(
                        `${Prefix.api}/lead/lead-update/${id}`,
                        {
                            headers: {
                                Authorization: `Token ${SecureStorage.getItem("token")}`,
                            },
                        }
                    );
                } else {
                    var { data } = await AXIOS.get(
                        `${Prefix.api}/lead/lead-update/${id}`,
                        {
                            headers: {
                                Authorization: `Token ${SecureStorage.getItem("token")}`,
                            },
                        }
                    );
                }
                dispatch({ type: ACTIONS.GET_NEW_LEAD_DETAILS, payload: data });
            } catch (err: any) {
                handleApiError(err, dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };

export const raiseNewTicektDisposition =
    (body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/redtech/csticket/create/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.RAISE_NEW_RAISE_TICEKT_DISPOSITION,
                payload: data,
            });
            snackBarUpdate({
                payload: {
                    message: "Ticket Created successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getLeadPrescriptionData = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LEAD_PRESCRIPTION_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/lead_prescription/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_LEAD_PRESCRIPTION_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LEAD_PRESCRIPTION_LOADING, payload: false });
        throw err;
    }
};
export const getPackageAutoSelected = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_AUTOSELECTED_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${PrefixBeta.api}/core/packages/crmdata${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES_AUTO_SELECTED, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getReportData = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_HELTHDATA_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/healthdata/report-values/${url ? url : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_REPORT_DATA,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_HELTHDATA_LOADING, payload: false });
        throw err;
    }
};
export const getHealthTestParameter =
    (url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/healthdata/test-params/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_HEALTH_TEST_PARAMETER,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getParameterCount = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/healthdata/test-params/${url ? url : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_PARAMETER_COUNT,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const addRemarkOnCall =
    (leadId: any, body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/communication/call_status/${leadId}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.ADD_REMARK_ON_CALL, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const allotToPhaBooking = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/booking/allot-to-pha/`,
            body,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.ALOT_TO_PHA_BOOKING, payload: data });
        snackBarUpdate({
            payload: {
                message: "Updated",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const clickToCallLead =
    (id: number, contact_type: string) => async (dispatch: Function) => {
        try {
            await AXIOS.get(`${Prefix.api}/lead/clicktocall_4cclead/${id}/`, {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            });
            dispatch({ type: ACTIONS.CLICK_TO_CALL_LEAD, payload: null });
            snackBarUpdate({
                payload: {
                    message: "Call Succeded",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getAditionalBookingWithTatTime =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/additional_booking/${url ? `${url}/?tat=true&pickup_status=confirmed` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_ADDITIONAL_BOOKING_LIST_WITH_TAT_TIME,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.GET_BOOKING_LIST_WITH_TAT_TIME, payload: [] });
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getAgentNewData = (url: string) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/panel-user-drop-down-list/${url ? `${url}` : ""}&data_required=recording`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_AGENTS_NEW_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getAllBookingsExports =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/cc_booking/${url ? `?${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_ALL_BOOKING_EXPORTS, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.GET_ALL_BOOKING_EXPORTS, payload: [] });
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getAllBookingsWithTatTime =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/data/${url ? `?${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_BOOKING_LIST_WITH_TAT_TIME, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.GET_BOOKING_LIST_WITH_TAT_TIME, payload: [] });
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getAllVerificationBookings = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/cc_booking/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_VERIFICATION_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_BOOKING_VERIFICATION_LIST, payload: [] });
        dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: false });
        throw err;
    }
};
export const getBookingJourney = (id: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/journey-details/${id ? `${id}/` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_JOURNEY_DETAILS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getBookingOverview =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/booking/overview/${url ? `?${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_BOOKING_OVERVIEW, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getCCPackage =
    (centre: string, city: string, name: string) =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.SET_LOADING, payload: true });
            try {
                const { data } = await AXIOS.get(
                    `${Prefix.api}/package/cc-package/${centre ? `?center=${centre}&cityid=${city}&name=${name}` : ""
                    }`,
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                );
                dispatch({ type: ACTIONS.GET_CC_PACKAGES, payload: data });
            } catch (err: any) {
                handleApiError(err, dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };
export const getCentre = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/data/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_CENTER, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getLabCredential = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/sample/lab_cre/${url ? url : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );

        dispatch({
            type: ACTIONS.GET_LAB_CREDENTIAL,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPaymentInfo = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/payment/info/${url ? url : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PAYMENT_INFORMATION, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getCollectionSlot =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/phlebo/timeslots/${url ? `?q=${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_COLLECTION_SLOT, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getVerifiedbyList =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/panel/data/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_VERIFIED_BY_LIST, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getPhleboTimeline = (id: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/data/${id ? `${id}/?tracker=true` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PHLEBO_TIMELINE, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getDispositions = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/lead/disposition_details/${url ? `?${url}` : ""}`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_DISPOSITIONS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getHotleads = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/center_lead/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_HOTLEADS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);

        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPanelUserList = (url: any) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/panel/data/${url ? `?code=${url}&usergroup=SalesLead` : "?usergroup=SalesLead"
            }`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_PANEL_USER_LIST_DATA,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getPanelUserListTeamLead =
    (url: any) => async (dispatch: Function) => {

        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/panel/data/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_PANEL_USER_LIST_DATA_TEAM_LEAD,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);

            throw err;
        }
    };
export const getPerformanceData =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_PERFORMANCE_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/panel/team-performance/${url ? `?${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_PERFORMANCE_DATA, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_PERFORMANCE_LOADING, payload: false });
            throw err;
        }
    };
export const getRefundPaymentList =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_REFUND_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/payment/refund-payment/${url ? url : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_PAYMENT_REFUND_LIST, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_REFUND_LOADING, payload: false });
            throw err;
        }
    };
export const getTicketCommentsForDocument = (id: number) => async (
    dispatch: Function
) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/redtech/csticket/details/${id}`,

            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({
            type: ACTIONS.GET_TICKET_COMMENTS_FOR_DOCUMENTS,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getVerificationBookingDetails =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/communication/verification_booking_call/${url ? `?${url}` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({
                type: ACTIONS.GET_VERIFICATION_BOOKING_DETAILS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getViewPagination =
    (url: string) => async (dispatch: Function) => {
        try {
            const { data } = await AXIOS.get(`${url.replace("http", "https")}`, {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            });

            dispatch({
                type: ACTIONS.GET_SF_VIEWS,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };
export const getViews = (id: string) => async (dispatch: Function) => {
    try {
        const url = id ? `/?view_id=${id}` : "/list/";
        const { data } = await AXIOS.get(
            `${Prefix.apiv2}/snowflake/default${url}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        if (url === "/list/") {
            dispatch({
                type: ACTIONS.GET_SF_VIEWS_DROPDOWN,
                payload: data,
            });
        } else {
            dispatch({
                type: ACTIONS.GET_SF_VIEWS,
                payload: data,
            });
        }
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};
export const leadTransferByComma =
    (body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        const { lead_ids, value, panel_user, status_call, count, priority } = body;

        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/panel/lead-transfer/`,
                { lead_ids, value, panel_user, status_call, count, priority },
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.LEAD_TRANSFER_BY_COMMA, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Transferred!",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const postAddRemoveTest =
    (paymentData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.post(
                `${Prefix.api}/booking/add_remove/`,
                paymentData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.POST_ADD_REMOVE_TEST, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Data successfully saved!",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateFailedReportStatus =
    (id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}//booking/failed-report/${id}/`,

                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_FAILED_REPORT_STATUS, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Report Updated Successfully ",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateHotleads =
    (id: any, formdata: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/center/center_lead/${id ? `${id}` : ""}`,
                formdata,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_HOTLEADS, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateInitiateRefund =
    (id: any, body: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/payment/refund-payment/${id}/`,
                body,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_INITIATED_REFUND, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Refund Initiate Updated successfully!",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getBookingCalls = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/communication/booking_call/${url ? `?booking=${url}` : ""
            }`,

            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_CALLS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getPackageData = (url: string) => async (dispatch: Function) => {

    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/package/crmdata/${url ? `?${url}` : ""}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_PACKAGES_DATA, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getGrievance =
    (url: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_GRIEVANCE_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/redtech/greviance-tickets/${url ? `${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_GRIEVANCE, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);

            dispatch({ type: ACTIONS.SET_GRIEVANCE_LOADING, payload: false });
            throw err;
        }
    };
export const updateGrivance =
    (bookingData: any, id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.patch(
                `${Prefix.api}/redtech/greviance-tickets/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_GRIVANCE_DATA, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Sucessfully Updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const updateRecordingDispostion =
    (id: any, bookingData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/communication/offline-record-dispo/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_RECORDING_DISPOSTION, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Family member updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const addUniqueCustomer = (body: any) => async (dispatch: Function) => {
    try {
        // const { data } = await AXIOS.post(`${Prefix.api}/cart/add-member/`, body, {
        const { data } = await AXIOS.post(`${Prefix.api}/cart/add-member-updated/`, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.ADD_UNIQUE_CUSTOMER, payload: data });
        snackBarUpdate({
            payload: {
                message: "Member Created.",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};
export const getLeadsNew = (body: any, url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(`${Prefix.api}/panel/search-unique_customer/${url ? `?${url}` : ""}`, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.GET_LEADS_NEW, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const getExportedGrievance =
    (url: string) => async (dispatch: Function) => {
        // dispatch({ type: ACTIONS.SET_GRIEVANCE_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/redtech/greviance-tickets/${url ? `${url}` : ""}`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_EXPORTED_GRIEVANCE, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };
export const getTestList = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/booking-packages/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_TEST_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};


export const getMrrSupportTickets = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/mrr-support-dashboard/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_MRR_SUPPORT_TICKET, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const updateMrrTicketStatus =
    (formdata: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/center/mrr-support-update/${formdata.id}/`,
                formdata.data,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_MRR_TICKET, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Ticket updated",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getRateListPackages =
    (id: string, url: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.get(
                `${Prefix.api}/center/ratelist-details/${id}/${url ? `?name_or_code=${url}` : ""
                }`,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.GET_RATELIST_PACKAGES, payload: data });
        } catch (err: any) {
            handleApiError(err, dispatch);

            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getPackageOffline =
    (centre: string, name: string, username: string, url: any) =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.SET_LOADING, payload: true });
            try {
                const { data } = await AXIOS.get(
                    `${Prefix.api}/package/cc-package/${centre
                        ? `?center=${centre}&name=${name}&username=${username}${url ? `&test_ids=${url}` : ""
                        }`
                        : ""
                    }`,
                    {
                        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                    }
                );
                if (url) {
                    dispatch({ type: ACTIONS.GET_PACKAGES_BY_ID, payload: data });
                } else {
                    dispatch({ type: ACTIONS.GET_PACKAGES_FOR_OFFLINE, payload: data });
                }
            } catch (err: any) {
                handleApiError(err, dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };

export const getMrrSupportComments = (url: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/mrr-support-comments/${url ? `${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_MRR_SUPPORT_COMMENTS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};


export const postMrrSupportComment = (body: any) => async (dispatch: Function) => {
    try {

        const { data } = await AXIOS.post(`${Prefix.api}/center/mrr-support-comments/
                `, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.POST_MRR_SUPPORT_COMMENT, payload: data });
        snackBarUpdate({
            payload: {
                message: "Comment Added",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};

export const createClincialTicket = (body: any) => async (dispatch: Function) => {
    try {

        const { data } = await AXIOS.post(`${Prefix.api}/center/mrr-support-create/?ccsupport=true
                `, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({ type: ACTIONS.POST_CLINICAL_HISTORY, payload: data });
        snackBarUpdate({
            payload: {
                message: "Clinical History Ticket Created",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        handleApiError(err, dispatch);

        throw err;
    }
};

export const getLedgerDetails = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.GET_CLIENT_LEDGER_DETAILS_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/package/cc-ledger/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_CLIENT_LEDGER_DETAILS, payload: data });

    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_CLIENT_LEDGER_DETAILS_LOADING, payload: false });

        throw err;
    }

};

export const getLedgerBalance = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/center/cc_centre_balance/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_CLIENT_LEDGER_BALANCE, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.GET_CLIENT_LEDGER_BALANCE, payload: [] });
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};

export const refundTDS = (bookingData: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(
            `${Prefix.api}/package/tds-refund/`,
            bookingData,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.TDS_REFUND, payload: data });
        showSuccessToast("saved!.", dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFranchiseInquiryList = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-inquiry-list/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_INQUIRY_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFranchiseInquiryDataById = (id: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-inquiry/${id ? `${id}/` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_INQUIRY_DATA_BY_ID, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFranchiseDispositionList = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-disposition-list/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_DISPOSITION_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const updateFranchiseData =
    (id: any, bookingData: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });
        try {
            const { data } = await AXIOS.put(
                `${Prefix.api}/service/franchise-inquiry/update/${id}/`,
                bookingData,
                {
                    headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
                }
            );
            dispatch({ type: ACTIONS.UPDATE_FRANCHIES_DATA, payload: data });
            snackBarUpdate({
                payload: {
                    message: "Data Updated Successfully",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getFranchiseAssignUserList = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-assign-user-list/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_ASSIGNE_USER_LIST, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getFranchiseInquiryByUser = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-inquiry-by-user/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_INQUIRY_BY_USER, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const clickToCallMobile =
    (id: number, contact_type: string) => async (dispatch: Function) => {
        try {
            await AXIOS.get(`${Prefix.api}/lead/clicktocallmobile_cclead/${id}/`, {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            });
            dispatch({ type: ACTIONS.CLICK_TO_CALL_MOBILE, payload: null });
            snackBarUpdate({
                payload: {
                    message: "Call Succeded",
                    status: true,
                    type: "success",
                },
            })(dispatch);
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };
export const getFranchiseInquiryLogs = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/service/franchise-inquiry-logs/${url ? `?${url}` : ""}`,
            {
                headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
            }
        );
        dispatch({ type: ACTIONS.GET_FRANCHIES_INQUIRY_LOGS, payload: data });
    } catch (err: any) {
        handleApiError(err, dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const createFranchiseInquiry = (body: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
        const { data } = await AXIOS.post(`${Prefix.api}/service/franchise/`, body, {
            headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        });
        dispatch({
            type: ACTIONS.CREATE_FRACHIES_INQUIRY,
            payload: data,
        });
        snackBarUpdate({
            payload: {
                message: "Lead Created Successfully",
                status: true,
                type: "success",
            },
        })(dispatch);
    } catch (err: any) {
        let title = "";
        if (err.response) {
            title = err.response.data.message;
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title || "Something went wrong",
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_LOADING, payload: false });
        throw err;
    }
};
export const getBookingDocument = (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: true });
    try {
        const { data } = await AXIOS.get(
            `${Prefix.api}/booking/get_booking_document/?booking_id=${id}`,
            { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
        );
        dispatch({ type: ACTIONS.GET_BOOKING_DOCUMENT, payload: data });
    } catch (err: any) {
        let title = "";
        if (err?.response?.data?.detail) {
            title = JSON.stringify(err.response.data?.detail).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else if (err?.response?.data?.errors) {
            title = JSON.stringify(err.response.data?.errors).replace(
                /"|{|}|[|]/g,
                ""
            );
        } else if (err?.response?.data?.msg) {
            title = JSON.stringify(err.response.data?.msg).replace(/"|{|}|[|]/g, "");
        } else {
            title = "Something went wrong!";
        }
        snackBarUpdate({
            payload: {
                message: title,
                status: true,
                type: "error",
            },
        })(dispatch);
        dispatch({ type: ACTIONS.SET_ALL_BOOKING_LOADING, payload: false });
        throw err;
    }
};
export const getTechTicket =
    (query: string = "") =>
        async (dispatch: Function) => {
            dispatch({ type: ACTIONS.SET_LOADING, payload: true });

            try {
                const { data } = await AXIOS.get(
                    `https://tasks.redcliffelabs.com/api/issues/by-project${query}`,
                    {
                        headers: {
                            "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                        },
                    },
                );

                dispatch({
                    type: ACTIONS.GET_TECH_TICKET,
                    payload: data || [],
                });
            } catch (err: any) {
                handleApiError(err, dispatch);
                dispatch({ type: ACTIONS.SET_LOADING, payload: false });
                throw err;
            }
        };

export const postTechTicket = (body: any) => async (dispatch: Function) => {
    try {
        const { data } = await AXIOS.post(
            "https://tasks.redcliffelabs.com/api/issues/",
            body,
            {
                headers: {
                    "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                },
            },
        );

        snackBarUpdate({
            payload: {
                message: "Tech Ticket Created",
                status: true,
                type: "success",
            },
        })(dispatch);

        dispatch({
            type: ACTIONS.POST_TECH_TECKET_CREATED,
            payload: data,
        });
    } catch (err: any) {
        handleApiError(err, dispatch);
        throw err;
    }
};


export const postTechTicketIssueAttacment =
    (body: any) => async (dispatch: Function) => {
        try {
            const { id, formData, uploaded_by } = body;

            // Add uploaded_by to formData if provided
            if (uploaded_by) {
                formData.append("uploaded_by", uploaded_by);
            }

            const { data } = await AXIOS.post(
                `https://tasks.redcliffelabs.com/api/public/project-attachments/${id}`,
                formData,
                {
                    headers: {
                        "X-API-Key": "rcl-project-dsdf3434-sdcsd-34sdzcs",
                        "Content-Type": "multipart/form-data",
                    },
                },
            );

            snackBarUpdate({
                payload: {
                    message: "Tech Ticket  Attachment Added ",
                    status: true,
                    type: "success",
                },
            })(dispatch);

            dispatch({
                type: ACTIONS.POST_TECH_TECKET_ATTACHEMENT,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };

export const postTechTicketComment =
    (body: any) => async (dispatch: Function) => {
        try {
            const { data } = await AXIOS.post(
                "https://tasks.redcliffelabs.com/api/comments/",
                body,
                {
                    headers: {
                        "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                    },
                },
            );

            snackBarUpdate({
                payload: {
                    message: "Comment Added",
                    status: true,
                    type: "success",
                },
            })(dispatch);

            dispatch({
                type: ACTIONS.POST_TECH_TECKET_COMMENT_ADDED,
                payload: data,
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            throw err;
        }
    };

export const getTechTicketActivites =
    (id: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `https://tasks.redcliffelabs.com/api/issues/${id}/activities`,
                {
                    headers: {
                        "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                    },
                },
            );

            dispatch({
                type: ACTIONS.GET_TECH_TICKET_ACTIVITIES,
                payload: data || [],
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getTechTicketComments =
    (id: any) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `https://tasks.redcliffelabs.com/api/comments/?issue_id=${id}`,
                {
                    headers: {
                        "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                    },
                },
            );

            dispatch({
                type: ACTIONS.GET_TECH_TICKET_COMMENTS,
                payload: data || [],
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getTechTicketAttacment =
    (id: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `https://tasks.redcliffelabs.com/api/issues/${id}/attachments`,
                {
                    headers: {
                        "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                    },
                },
            );

            dispatch({
                type: ACTIONS.GET_TECH_TICKET_ATTACMENTS,
                payload: data || [],
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };

export const getTechTicketUserDetails =
    (email: string) => async (dispatch: Function) => {
        dispatch({ type: ACTIONS.SET_LOADING, payload: true });

        try {
            const { data } = await AXIOS.get(
                `https://tasks.redcliffelabs.com/api/users/email/${email}`,
                {
                    headers: {
                        "project-id": "abaa4885-7740-413c-9f6d-4d122ef14a2c",
                    },
                },
            );

            dispatch({
                type: ACTIONS.GET_TECH_TICKET_USER_DETAILS,
                payload: data || [],
            });
        } catch (err: any) {
            handleApiError(err, dispatch);
            dispatch({ type: ACTIONS.SET_LOADING, payload: false });
            throw err;
        }
    };








